import React, { useState, useEffect } from "react";
import { Button, Stack, Grid } from "@mui/material";
import Room from "./Room";
import { useParams } from "react-router-dom";

const EngineerCallScreen = () => {
  const { id } = useParams();
  const [isexpired, setIsExpired] = useState(false);
  const [rendercontent, setRendercontent] = useState(false);

  const [conf, setConf] = useState({
    connection: false,
    roomId: "",
    //used isEngineer previously, not used now
    isEngineer: true,
    audio: true,
    video: true,
    iceServers: [
      {
        urls: "stun:4.186.152.93:3478",
      },
      {
        urls: "turn:4.186.152.93:3478",
        username: "TURNu",
        credential: "TURNp",
      }

    ],
    socketIoPath: process.env.REACT_APP_API_URL,
  });

  const urlparams = new URLSearchParams(window.location.search);
  const expirationtime = parseInt(urlparams.get("tf"));
  const currenttime = Date.now();
  const storedLink = localStorage.getItem("customlink");

  useEffect(() => {
    const checkexpiry = () => {
      if (currenttime >= expirationtime) {
        setIsExpired(true);
      } else {
        setIsExpired(false);
      }
      console.log("the url params", urlparams);
      console.log("the currenttime", expirationtime);
      console.log("the link is", window.location.href);
      console.log("the stored  is", storedLink);
    };

    checkexpiry();

    const interval = setTimeout(() => {
      console.log("checking expiration");
      checkexpiry();
      setRendercontent(true);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [expirationtime, currenttime]);


  useEffect(() => {
    getRoomIdAndConnect("");
  }, []);

  const setConfigurattion = (args) => {
    let tempConf = { ...conf };
    args.forEach((element) => {
      tempConf[element.type] = element.value;
    });
    setConf(tempConf);
  };

  const getRoomIdAndConnect = (engineerId) => {
    setConfigurattion([
      { type: "connection", value: true },
      { type: "roomId", value: id },
    ]);
  };
  const OnError = (msg) => {
    setConfigurattion([{ type: "connection", value: false }]);
    if (msg === "Permission denied") {
      alert("Please allow all permissions to proceed");
      alert(
        "Please click on secure icon before https://... and select site settings then camera permission"
      );
      alert(
        "Please click on secure icon before https://... and select site settings then microphone permission"
      );
    } else {
      console.log(msg);
      alert("Your system is not capable to have video call");
    }
  };
  const onClose = () => {
    setConfigurattion([{ type: "connection", value: false }]);
  };
  return (
    <>
      {isexpired || window.location.href != storedLink ?
        (
          <h1>The link is not valid</h1>
        ) : (
          <div
            style={{
              height: "100vh",
              background: "rgb(0,0,0)",
              background:
                "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(119,119,119,1) 50%, rgba(0,0,0,1) 100%)",

            }}
          >
            {!conf.connection && (
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "45vh",
                }}
              >
                <Stack direction="row" spacing={1} p={1}>
                  <Button variant="contained" onClick={() => getRoomIdAndConnect("")}>
                    Join
                  </Button>
                </Stack>
              </Grid>
            )}
            {conf.connection && (
              <Grid container>
                <Room conf={conf} onClose={onClose} OnError={OnError} />
              </Grid>
            )}
          </div>
        )
      }
    </>
  );
};

const Engineer = () => {
  return <EngineerCallScreen />;
};

export default Engineer;
